import { Routes, Route, useNavigate } from "react-router-dom";
import { MsalProvider } from '@azure/msal-react';
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { ToastContainer, Zoom } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import Login from "./pages/Login";
import NotFound from "./pages/Error";
import Menu from "./pages/Menu";
import ProductionMi from "./pages/ProductionMi";
import ProductionOh from "./pages/ProductionOh";
import ProductionMUSe from "./pages/ProductionMUSe";
import BuildStatusMiFront from "./pages/BuildStatusMiFront";
import BuildStatusMiRear from "./pages/BuildStatusMiRear";
import BuildStatusOh from "./pages/BuildStatusOh";
import BuildStatusMUSe from "./pages/BuildStatusMUSe";

function App({ instance }) {
  const userToken = useSelector((state) => state?.user?.token);
  const navigate = useNavigate();

  useEffect(() => {
    if (userToken === "error") {
      navigate("/");
      const account = instance.getActiveAccount();
      if (account) {
        console.log("account", account);
        const logoutRequest = {
          // idTokenHint: accessToken,
          account: account,
          postLogoutRedirectUri: "/",
          mainWindowRedirectUri: "/",
        };
        instance.logoutRedirect(logoutRequest).catch((e) => {
          console.error(e);
        });
      }
    }
  }, [userToken]);

  return (
    <MsalProvider instance={instance}>
      <ToastContainer draggable={false} transition={Zoom} autoClose={3000} style={{ width: "100%", textAlign: "center", fontSize: "100%" }} hideProgressBar />
      <Routes>
        <Route>
          <Route path="/" element={<Login />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route>
          <Route exact path="/mes/menu" element={<Menu />} />
          <Route exact path="/mes/production/mi" element={<ProductionMi />} />
          <Route exact path="/mes/production/oh" element={<ProductionOh />} />
          <Route exact path="/mes/production/muse" element={<ProductionMUSe />} />
          <Route exact path="/mes/buildstatus/mi/front" element={<BuildStatusMiFront />} />
          <Route exact path="/mes/buildstatus/mi/rear" element={<BuildStatusMiRear />} />
          <Route exact path="/mes/buildstatus/oh" element={<BuildStatusOh />} />
          <Route exact path="/mes/buildstatus/muse" element={<BuildStatusMUSe />} />
        </Route>
      </Routes>
    </MsalProvider>
  );
}

export default App;